@import "igws-accordion.less";

.accordion--plus, 
.accordion--arrow {
  &::after {
    right: 0;
  }  
}

@media (max-width: @medium-breakpoint) {
    .accordion--plus, 
    .accordion--arrow {
      &::after {
        right: 10px;
      }
    }
  }